module.exports = __webpack_public_path__ + "static/en-1-9263bbe1927801845fba0d285395db6a.png";